/* istanbul ignore file */

export const CLOSE_TIMEOUT_MS = 250;
